
import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import { Link, NavLink } from 'react-router-dom'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import DynamicGradientTables from '../../../../../_components/common/DynamicGradientTables'
import { class_name_first, data_first, class_name_second } from './LandDData'

// import CircularButtonGroup from '../../../../../_components/common/CircularButtonGroup'
import './index.css'
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';
import { lndAction } from '../../../../../_actions/Analyze/lnd.action'
import dataFormater from '../../dataFormater'
import {global_data} from '../../globalData'



class LAndD extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamName: '',
            teamId: '',
            getPaUserPermissionListResponse: '',
            selection_id: 1,
            selected_route_parameter: null,
            navData: [],
            data_second: [],
            filterData: null
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.lndDataResponse !== this.props.lndDataResponse) {
            if(this.props.lndDataResponse !== '') {
                this.setState({data_second: []},() => {
                    this.setState({data_second: dataFormater(this.props,this.props.lndDataResponse.data,"lnd_all")},() => {
                    })
                })
            }
        }

        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
                })
            }
        }

        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '') {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'L&D') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        //filter data
        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
            })
        }

        //Heading permission
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        //lnd data
        if(this.props.lndDataResponse !== '') {
            this.setState({data_second: dataFormater(this.props,this.props.lndDataResponse.data,"lnd_all")},() => {
            })
        }
    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    render() {
        const { navData } = this.state;
        const { saveAssesorGroupListResponse } = this.props;


        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        {
                            this.props.getlndLoading ?
                                <p className="text-center m-3">
                                    <i className="fas fa-spinner fa-spin " ></i>
                                    &nbsp;loading
                                </p>
                            :
                                <div>
                                    {
                                        this.props.singleValidatorResponse ?
                                        <p className="text-center">
                                                Team Members should be more than 2
                                        </p>:
                                        <div className="swot-container-sub">
                                            {
                                                this.props.errorMessageLandD.length === 0 ?
                                                    <div>
                                                        <div className="gradient-flex  pt-5">
                                                            <DynamicGradientTables classNameProps={class_name_first} data={data_first} />
                                                        </div>
                                                        <div className="gradient-flex pb-2">
                                                            
                                                            <DynamicGradientTables key={this.state.data_second} classNameProps={class_name_second} data={this.state.data_second} />
                                                        </div>
                                                    </div>
                                                :
                                                    <p class="m-3">{this.props.errorMessageLandD}</p>
                                            }
                                        </div>
                                    }
                                </div>
                        }
                    </div>
                </ div>
            </div>


        );
    }
}


function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    //Competency data
    const { getlndLoading } = state.lndDataReducer
    const getlndError = state.lndDataReducer.error
    const errorMessageLandD = state.lndDataReducer.errorMessage
    const lndDataResponse = (!getlndLoading && !getlndError) ?  state.lndDataReducer.data : '';

     //Header Permission
     const { headPerLoading } = state.headerPermissionReducer
     const headPerLoadingError = state.headerPermissionReducer.error
     const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;

    const singleValidatorResponse = state.singleValidatorReducer.data;

    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        getlndLoading,
        lndDataResponse,
        errorMessageLandD,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,
        singleValidatorResponse
    }
}

export default connect(mapStateToProps)(LAndD)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/L&D/index.js